import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useCallback, useRef } from 'react';
import { useUserContext } from '../../common/user-context';
import { addRecentSearch, RECENT_SEARCH_KEY } from '@atlassian/search-common';
import { useProductContext } from '../product-router';
import { useQuery } from '../query-context';
export var usePersistRecentSearches = function usePersistRecentSearches(overrideQuery) {
  var previousQuery = useRef(null);
  var _useUserContext = useUserContext(),
    user = _useUserContext.user;
  var _useQuery = useQuery(),
    query = _useQuery.query;
  var _useProductContext = useProductContext(),
    getActiveProduct = _useProductContext.getActiveProduct;
  var product = getActiveProduct();
  var persistRecentSearch = useCallback(function () {
    if (user !== null && user !== void 0 && user.id && product !== null && product !== void 0 && product.id) {
      if (overrideQuery && overrideQuery.trim() !== '') {
        addRecentSearch(overrideQuery, user.id, product.id, RECENT_SEARCH_KEY);
      } else if (previousQuery.current !== query && query.trim() !== '') {
        addRecentSearch(query, user.id, product.id, RECENT_SEARCH_KEY);
        previousQuery.current = query;
      }
    }
  }, [product === null || product === void 0 ? void 0 : product.id, query, user.id, overrideQuery]);
  var onClick = useCallback(function () {
    persistRecentSearch();
  }, [persistRecentSearch]);
  var onEnter = useCallback(function (event) {
    if (event.key === 'Enter') {
      persistRecentSearch();
    }
  }, [persistRecentSearch]);
  return [onClick, onEnter];
};

/**
 * This component is used in {@link MetaContextProvider} to intercept
 * clicks and enter hit of any kind (eg - result, filter, feedback, input etc).
 */
export var PersistRecentSearch = function PersistRecentSearch(_ref) {
  var children = _ref.children,
    overrideQuery = _ref.overrideQuery;
  var _usePersistRecentSear = usePersistRecentSearches(overrideQuery),
    _usePersistRecentSear2 = _slicedToArray(_usePersistRecentSear, 2),
    onClick = _usePersistRecentSear2[0],
    onEnter = _usePersistRecentSear2[1];
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    React.createElement("div", {
      onClick: onClick,
      onKeyDown: onEnter
      // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
      ,
      style: {
        width: '100%'
      },
      "data-testid": "persist-recent-search"
    }, children)
  );
};